import script from "./DetailContent.vue?vue&type=script&lang=ts&setup=true"
export * from "./DetailContent.vue?vue&type=script&lang=ts&setup=true"

import "./DetailContent.vue?vue&type=style&index=0&id=26d3d2eb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26d3d2eb"]])

export default __exports__